import React from "react";
import styles from "./style.module.scss";

const XpressTermsContent = () => {
  return (
    <div className={styles.termsContent}>
      <h1>XPRESS TERMS AND CONDITIONS</h1>

      <h2>1. DEFINITIONS</h2>
      <h3>1.1. For the purposes of this Agreement:</h3>
      <p>
        (a) &ldquo;Authorized Reseller&rdquo; means Canco-branded service stations in Canada
        or such other territories as notified by Canco from time to time, accepting Xpress Fleet
        Cards for purchases of Products and Services, as Canco may designate from time to time;
      </p>
      <p>
        (b) &ldquo;Authorized User&rdquo; means the Customer or any natural person designated
        in writing by the Customer from time to time to whom Canco issues an Xpress Fleet Card at
        the request of the Customer;
      </p>
      <p>
        (c) &ldquo;Business Day&rdquo; means Monday to Friday inclusive of each week, excluding
        days which are statutory holidays in the Province of British Columbia. If the date for
        the performance of any act or thing falls on a day that is not a Business Day, then the
        date for the performance of such act or thing will be extended to the next Business Day;
      </p>
      <p>
        (d) &ldquo;Charges&rdquo; means all amounts howsoever charged to each Xpress Fleet Card,
        any late payment charges or other amounts due and payable to Canco hereunder and all other
        costs, fees or expenses, including without limitation, legal fees on a full indemnity
        basis, incurred by Canco in relation to or in connection with any or all Xpress Fleet
        Cards issued by Canco hereunder or the recovery of any of such amounts, charges, costs,
        fees or expenses payable hereunder;
      </p>
      <p>
        (e) &ldquo;Maximum Account Balance&rdquo; means the maximum total unpaid amount
        chargeable to the Customer&rsquo;s Xpress Fleet Card Account as may be determined or
        amended by Canco from time to time, in Canco&rsquo;s sole and absolute discretion, and
        communicated by Canco to the Customer from time to time;
      </p>
      <p>
        (f) &ldquo;Maximum Card Number&rdquo; means the maximum of Xpress Fleet Cards for an
        Xpress Fleet Card Account as may be determined or amended by Canco from time to time, in
        Canco&rsquo;s sole and absolute discretion, and communicated by Canco to the Customer
        from time to time;
      </p>
      <p>
        (g) &ldquo;Maximum Transaction Amount&rdquo; means the maximum amount chargeable to an
        Xpress Fleet Card for any single transaction as may be determined or amended by Canco
        from time to time, in Canco&rsquo;s sole and absolute discretion, and communicated by
        Canco to the Customer from time to time;
      </p>
      <p>
        (h) &ldquo;Maximum Transaction Uses&rdquo; means the maximum transactions per day per
        Xpress Fleet Card as may be determined or amended by Canco from time to time, in
        Canco&rsquo;s sole and absolute discretion, and communicated by Canco to the Customer
        from time to time;
      </p>
      <p>
        (i) &ldquo;Notification of Loss&rdquo; means any notice in writing from the Customer to
        Canco reporting the loss or theft of an Xpress Fleet Card;
      </p>
      <p>
        (j) &ldquo;Other Products&rdquo; means such products expressly approved by Canco from
        time to time being products which are offered for sale by an Authorized Reseller and
        which may be charged to an Xpress Fleet Card in Canco&rsquo;s sole and absolute
        discretion;
      </p>
      <p>
        (k) &ldquo;PIN&rdquo; means the personal identification number activated and utilized by
        the Customer from time to time for use in conjunction with an Xpress Fleet Card;
      </p>
      <p>
        (l) &ldquo;Products&rdquo; means available gasoline (regular and premium), diesel, and
        lubricants offered for sale by an Authorized Reseller, the purchase of which may be
        charged to an Xpress Fleet Card in Canco&rsquo;s sole and absolute discretion;
      </p>
      <p>
        (m) &ldquo;Replacement Xpress Fleet Card&rdquo; means any Xpress Fleet Card specially
        issued by Canco in case of loss, theft or mutilation, as applicable, in accordance with
        this Agreement;
      </p>
      <p>
        (n) &ldquo;Services&rdquo; means services provided by an Authorized Reseller, or such
        other services approved by Canco in writing from time to time, the cost of which may be
        charged to the Xpress Fleet Card in Canco&rsquo;s sole and absolute discretion;
      </p>
      <p>
        (o) &ldquo;Xpress Application Form&rdquo; means the application form submitted on behalf
        of the Customer to Canco to apply for an Xpress Fleet Card on the basis of which Canco
        has issued a first Xpress Fleet Card to the Customer.
      </p>
      <p>
        (p) &ldquo;Xpress Application Submission Date&rdquo; means the date on which the Xpress
        Application Form is submitted on behalf of the Customer to Canco.
      </p>
      <p>
        (q) &ldquo;Xpress Fleet Card Account&rdquo; means the Xpress Fleet Card account of the
        Customer with Canco described and established by this Agreement;
      </p>
      <p>
        (r) &ldquo;Xpress Fleet Card&rdquo; means a card issued by Canco to the Customer
        pursuant to this Agreement; and
      </p>
      <p>
        (s) &ldquo;Xpress Fleet Card Invoice&rdquo; means an invoice issued by Canco or an
        Authorized Reseller indicating charges of Products, Charges, Other Products, or Services
        to an Xpress Fleet Card.
      </p>

      <h2>2. COMMENCEMENT</h2>
      <h3>2.1.</h3>
      <p>
        Notwithstanding the actual date of execution or delivery of this Agreement, or any other
        document delivered pursuant to this Agreement, the effective date of this Agreement shall
        be the Xpress Application Submission Date.
      </p>

      <h2>3. USE</h2>
      <h3>3.1.</h3>
      <p>
        All obligations of this Agreement, notwithstanding references made solely to the Customer,
        shall be a joint and several responsibility of the Customer and any Authorized User.
      </p>
      <h3>3.2.</h3>
      <p>
        The Customer shall bring the terms and conditions of this Agreement to the attention of
        any and all Authorized Users and shall ensure that any and all Authorized Users comply
        with the terms and conditions of this Agreement. Unless accepted earlier, any and all
        Authorized Users shall be deemed to accept the terms and conditions of this Agreement
        upon use of an Xpress Fleet Card.
      </p>
      <h3>3.3.</h3>
      <p>
        The Customer shall be responsible for any and all Xpress Fleet Cards issued by Canco at
        the Customer&rsquo;s request and for the Xpress Fleet Card Account.
      </p>
      <h3>3.4.</h3>
      <p>
        The release or discharge of liability or any invalidity or unenforceability in respect of
        a person using an Xpress Fleet Card shall not discharge or affect the liability of the
        Customer.
      </p>
      <h3>3.5.</h3>
      <p>
        The parties acknowledge and agree that an Xpress Fleet Card enables the Authorized User
        or a Customer to purchase certain Products, Other Products or Services as determined by
        Canco in Canco&rsquo;s sole and absolute discretion, from any Authorized Reseller and to
        charge such purchases to the Xpress Fleet Card, provided that Canco shall not, under any
        circumstances or in any way whatsoever, be bound to ensure the availability or provision
        of such Products, Other Products or Services, or be liable in the event of the
        non-availability or non-provision thereof.
      </p>
      <h3>3.6.</h3>
      <p>
        Canco may impose or alter credit limits, including without limitation the Maximum Account
        Balance, Maximum Transaction Amount, or Maximum Transaction Uses, unilaterally in
        Canco&rsquo;s sole and absolute discretion, at any time and without notice, with respect
        to any Xpress Fleet Card.
      </p>
      <h3>3.7.</h3>
      <p>
        The Customer agrees not to exceed, and to ensure that any and all Authorized Users do not
        exceed, credit limits of Xpress Fleet Cards. The Customer agrees to consent to any request
        by Canco for credit information or to obtain a credit report. The Customer agrees to
        consent, and hereby does consent, to any request by Canco for credit information from any
        bank or other financial, commercial or governmental entity.
      </p>
      <h3>3.8.</h3>
      <p>
        The Customer shall be responsible for and shall ensure that any and all Xpress Fleet Card
        Invoices, as the case may be, accurately reflect any and all purchases charged to an
        Xpress Fleet Card. All Xpress Fleet Card Invoices are hereby deemed as conclusive and
        binding upon the Customer and any other Authorized User for all purposes of this
        Agreement.
      </p>
      <h3>3.9.</h3>
      <p>Canco shall not, under any circumstances or in any way whatsoever, be liable or responsible for:</p>
      <p>
        (a) any act or omission of any Authorized Reseller including the refusal by or failure of
        any Authorized Reseller to honour any Xpress Fleet Card or for any loss or damage arising
        from any defects or deficiency in or complaints relating to Products, Services, or for
        any other problems or claims that the Customer or any Authorized User may have with or
        against an Authorized Reseller; or
      </p>
      <p>
        (b) any loss of profits, special, incidental, consequential, exemplary or punitive
        damages in any way related to or arising from this Agreement.
      </p>
      <h3>3.10.</h3>
      <p>
        Any dispute or claim the Customer or any Authorized User may have with or against an
        Authorized Reseller shall not affect the obligations of the Customer or an Authorized User
        under this Agreement.
      </p>
      <h3>3.11.</h3>
      <p>
        In all circumstances, the Customer shall pay the amounts of all Charges in full. Without
        limiting the generality of the foregoing, the Customer acknowledges and agrees that Canco
        may charge a non-sufficient funds (N.S.F.) fee of $45.00 to the Customer in each event
        that an attempt to collect funds is unsuccessful from Canco due to insufficient funds of
        the Customer.
      </p>
      <h3>3.12.</h3>
      <p>
        The Customer shall indemnify, save harmless, and keep Canco, each and all of Canco&rsquo;s
        affiliates, subsidiaries, officers, directors, shareholders, employees, contractors and
        agents, at all times indemnified against any and all claims, losses, damages, actions,
        demands, penalties, fines, costs or expenses (including without limitation, legal fees on
        a full indemnity basis) of any nature whatsoever and however arising which Canco may
        incur, sustain or suffer arising out of or relating to or in connection with the issuance
        of an Xpress Fleet Card to the Customer or to any Authorized User, or the use of an
        Xpress Fleet Card by the Customer or any Authorized User, or the use of Products, Other
        Products, or Services.
      </p>
      <h3>3.13.</h3>
      <p>
        The Customer represents the truth and accuracy of all information furnished or required
        to be furnished to Canco hereunder including without limitation the particulars of any and
        all Authorized Users.
      </p>
      <h3>3.14.</h3>
      <p>
        The Customer shall notify Canco in writing of any change of any particulars that have
        been furnished to Canco or any change of any Authorized Users or their particulars, which
        notification shall be given by the Customer within three (3) days of the relevant change,
        and which notification shall be effective on receipt by Canco of the same. Upon any such
        change, the Customer shall surrender any and all Xpress Fleet Cards relating to such
        Authorized User and Canco may issue a Replacement Xpress Fleet Card. The Customer shall
        be responsible and shall pay for any and all purchases of Products and Services charged
        to Xpress Fleet Cards, notwithstanding that an Authorized User is no longer so designated.
      </p>
      <h3>3.15.</h3>
      <p>
        The Customer shall at all times during this Agreement observe and perform, and shall
        ensure that all Authorized Users shall at all times during this Agreement observe and
        perform, all the terms and conditions set out in this Agreement, including without
        limitation:
      </p>
      <p>
        (a) take all reasonable care and precaution to prevent the loss, theft or mutilation of
        any and all Xpress Fleet Cards;
      </p>
      <p>
        (b) not reveal the PIN of any Xpress Fleet Card to any person other than an Authorized
        User;
      </p>
      <p>
        (c) reimburse Canco all costs and expenses, including without limitation legal fees on a
        full indemnity basis, which Canco may pay, incur or sustain in relation to any action
        taken to enforce the terms or conditions of this Agreement;
      </p>
      <p>
        (d) immediately inform Canco if the Customer or any Authorized User suspects that an
        Xpress Fleet Card is being used without the authorization of the Customer; and
      </p>
      <p>
        (e) inform Canco of any changes of the Customer&rsquo;s address or any and all Authorized
        Users within three (3) days of such change.
      </p>

      <h2>4. PAYMENT</h2>
      <h3>4.1.</h3>
      <p>
        The parties acknowledge and agree that the Maximum Account Balance and Maximum Card Number
        apply to the Xpress Fleet Account, unless otherwise expressly agreed to by Canco in
        writing.
      </p>
      <h3>4.2.</h3>
      <p>
        The parties acknowledge and agree that the Maximum Transaction Amount and the Maximum
        Transaction Uses apply to any and all Xpress Fleet Cards, unless otherwise expressly
        agreed to by Canco in writing.
      </p>
      <h3>4.3.</h3>
      <p>
        Canco may issue, from time to time, one or more Xpress Fleet Card Invoices to the
        Customer indicating the amount that is owed by the Customer to Canco.
      </p>
      <h3>4.4.</h3>
      <p>
        In all circumstances, the Customer shall pay in full the amounts stated in any and all
        Xpress Fleet Card Invoices as due and owing.
      </p>
      <h3>4.5.</h3>
      <p>
        The Customer shall furnish Canco, and at all times keep in effect, a valid and
        enforceable direct debit authorization, in a form suitable to Canco, authorizing Canco to
        debit the Customer&rsquo;s bank account for all Charges.
      </p>
      <h3>4.6.</h3>
      <p>
        The Customer shall ensure at all times that its bank or financial institution honours
        Canco&rsquo;s debits of its bank account and that such bank account remains in good
        standing and contains sufficient funds to pay all Charges in full.
      </p>
      <h3>4.7.</h3>
      <p>
        The Customer hereby authorizes Canco, and any and all of Canco&rsquo;s financial
        institutions, affiliates and subsidiaries, to debit any and all of the Customer&rsquo;s
        bank accounts, including without limitation the Customer&rsquo;s bank account described in
        the Xpress Application Form, at any time for any and all Charges:
      </p>
      <h3>4.8.</h3>
      <p>
        Canco may debit any and all of the Customer&rsquo;s bank accounts, at any time, in
        Canco&rsquo;s sole and absolute discretion, for any and all Charges charged to any and
        all of the Xpress Fleet Cards. For greater certainty, nothing contained herein shall be
        deemed to limit Canco&rsquo;s right to debit the Customer&rsquo;s bank account, or
        otherwise receive payment, with respect to any Charges for which Canco has not previously
        received payment in full for any reason.
      </p>

      <h2>5. LOSS OF CARD</h2>
      <h3>5.1.</h3>
      <p>
        The Customer shall immediately send to Canco a Notification of Loss, in writing, advising
        of the loss or theft of any and all Xpress Fleet Cards.
      </p>
      <h3>5.2.</h3>
      <p>
        The Customer shall be fully liable for all Charges incurred or accrued on any and all
        Xpress Fleet Cards notwithstanding Canco&rsquo;s receipt of a Notification of Loss. For
        greater certainty, the Customer shall be fully liable for all Charges, whether incurred or
        accrued against any and all Xpress Fleet Cards on, before or after Canco&rsquo;s receipt
        of a Notification of Loss from the Customer.
      </p>

      <h2>6. TERMINATION OF CARD</h2>
      <h3>6.1.</h3>
      <p>
        This Agreement, or any Xpress Fleet Card, may be terminated, revoked or cancelled by
        Canco at any time without prior notice, for any reason, with or without cause.
      </p>
      <h3>6.2.</h3>
      <p>
        Canco may, at any time, suspend the use of any Xpress Fleet Card with or without prior
        notice and for such period as Canco may, in its absolute and sole discretion, think fit.
      </p>
      <h3>6.3.</h3>
      <p>
        The Customer shall remain liable for all Charges, incurred in respect to any and all
        Xpress Fleet Cards after the termination, cancellation, revocation, suspension or request
        for cancellation of this Agreement or of any Xpress Fleet Card. No termination,
        cancellation, suspension or revocation of this Agreement shall affect the Customer&rsquo;s
        obligation and liability to effect full payment for any and all Charges and other amounts
        due to Canco under this Agreement.
      </p>
      <h3>6.4.</h3>
      <p>
        On the effective date of termination, cancellation, or revocation of this Agreement,
        regardless of the reason thereof, the Customer shall immediately pay and settle in full
        all Charges incurred on any and all Xpress Fleet Cards and shall return to Canco all the
        Xpress Fleet Cards issued to the Customer and all Authorized Users.
      </p>
      <h3>6.5.</h3>
      <p>
        The termination, cancellation, suspension or revocation of this Agreement or any Xpress
        Fleet Card shall be without prejudice to any and all of Canco&rsquo;s rights in respect
        of this Agreement.
      </p>

      <h2>7. REPLACEMENT OF CARD</h2>
      <h3>7.1.</h3>
      <p>
        Canco shall not at any time have any obligation to issue or cause to be issued any Xpress
        Fleet Card or any Replacement Xpress Fleet Card to the Customer or any Authorized User.
      </p>
      <h3>7.2.</h3>
      <p>
        The Customer acknowledges and agrees that any and all Xpress Fleet Cards issued pursuant
        to this Agreement are and shall remain the property of Canco at all times.
      </p>

      <h2>8. AMENDMENTS</h2>
      <h3>8.1.</h3>
      <p>
        Canco may, at any time and from time to time, amend any of the provisions of this
        Agreement by giving written notice to the Customer, in such manner as Canco may see fit in
        Canco&rsquo;s absolute and sole discretion. Any such amendment shall take effect seven (7)
        days after the date of the said notice of amendment, unless otherwise stated in such
        written notice. The Customer shall be deemed to have accepted and agreed to such amendment
        without reservation.
      </p>

      <h2>9. ASSIGNMENT</h2>
      <h3>9.1.</h3>
      <p>
        The Customer shall not assign, transfer or delegate any or all of its rights or
        obligations hereunder and any purported assignment, transfer or delegation shall be null
        and void. Canco may freely assign any or all of its rights, titles and interests.
        including without limitation, any claims or right to receive payment of any monies
        hereunder, in or contemplated under this Agreement without notice to the Customer.
      </p>

      <h2>10. NOTICES</h2>
      <h3>10.1.</h3>
      <p>
        Any notice, request, demand or other communication required or permitted to be given
        under this Agreement shall be in writing and delivered by hand, email, or prepaid
        registered mail to the party to which it is to be given as follows, or to such other
        address, or email address as a party may specify by notice given in accordance with this
        section:
      </p>
      <p>(a) To Canco at:</p>
      <p className={styles.noticeAddress}>
        CANCO PETROLEUM LTD.
        <br />
        200 - 125 Highway 33 East,
        <br />
        Kelowna, British Columbia, V1X 2A1
        <br />
        Email:{" "}
        <a href="mailto:xpress@cancopetroleum.ca">xpress@cancopetroleum.ca</a>
      </p>
      <p>
        (b) To the Customer at the business mailing address or contact email indicated in the
        Xpress Application Form.
      </p>
      <h3>10.2.</h3>
      <p>
        Any such notice, request, demand or other communication given as aforesaid by hand or
        prepaid registered mail shall be deemed to have been given when delivered.
      </p>
      <h3>10.3.</h3>
      <p>
        Any such notice, request, demand or other communication given as aforesaid by email will
        be deemed to have been given as follows:
      </p>
      <p>
        (a) if any notice, request, demand or other communication is transmitted by email before
        5:00 p.m. (Pacific Standard Time) on a Business Day, then it shall be conclusively deemed
        to have been given on that Business Day; and
      </p>
      <p>
        (b) if any notice, request, demand or other communication is transmitted by email after
        5:00 p.m. (Pacific Standard Time) on a Business Day or on a day that is not a Business
        Day, then it shall be conclusively deemed to have been given on the Business Day following
        the date of the transmission.
      </p>
      <h3>10.4.</h3>
      <p>
        In the event of discontinuance of postal service due to strike, lockout, labour
        disturbance or otherwise, notices, demands, requests and other communications shall be
        delivered by hand or by email.
      </p>

      <h2>11. GENERAL</h2>
      <h3>11.1.</h3>
      <p>Time shall be of the essence.</p>
      <h3>11.2.</h3>
      <p>All dollar amounts referred to in this Agreement are Canadian dollars.</p>
      <h3>11.3.</h3>
      <p>
        This Agreement shall be governed by and construed in accordance with the laws of the
        province of British Columbia and the parties submit and attorn to the exclusive
        jurisdiction of the courts of the province of British Columbia.
      </p>
      <h3>11.4.</h3>
      <p>
        This Agreement cancels and supersedes all previous agreements and contains the whole
        agreement between the parties on the subject matter hereof. It is expressly agreed that
        there are no agreements, conditions, representations, warranties, covenants, terms or
        undertakings, other than as may be implied by the applicable law that are not merged or
        superseded hereby.
      </p>
      <h3>11.5.</h3>
      <p>
        If any term or provision herein now or hereafter is judicially held or rendered by
        legislation invalid or unenforceable, or conflicts with any applicable regulations of any
        governmental authority having jurisdiction, such illegality or invalidity shall not affect
        any other provision of this Agreement, and this Agreement shall be interpreted as if such
        illegal or invalid clause or portion thereof had never been contained herein, or shall be
        deemed to be amended to conform thereto, as the case may be, and as so interpreted or
        amended shall continue in full force and effect.
      </p>
      <h3>11.6.</h3>
      <p>
        The parties shall execute and deliver all such further documents or do or cause to be
        done all such further acts and things, and give all such further assurances as may be
        necessary to give the full effect to the provisions and intent of this Agreement.
      </p>
      <h3>11.7.</h3>
      <p>
        The parties acknowledge having been advised to obtain independent legal, tax, and
        accounting advice with respect to this Agreement and has either done so or considered
        doing so and in its or his or her sole discretion and judgement has decided that such
        advice is not necessary.
      </p>
      <h3>11.8.</h3>
      <p>
        All covenants, terms, agreements, provisos and conditions contained in this Agreement
        shall enure to the benefit of and be binding on the parties hereto, their respective
        heirs, executors, administrators, successors and permitted assigns.
      </p>
      <h3>11.9.</h3>
      <p>
        The grammatical changes required to make the provisions of this Agreement apply in the
        plural sense where a party comprises more than one person and to corporations, firms,
        partnerships, or individuals male or female, will be assumed as though in each case fully
        expressed, and if a party consists of more than one person, the obligations of the party
        will be deemed to be joint and several obligations of each such person.
      </p>
      <h3>11.10.</h3>
      <p>
        Unless expressly provided for in this Agreement, no modifications of this Agreement shall
        be in force and effect unless made in writing and signed by all of the parties.
      </p>
      <h3>11.11.</h3>
      <p>
        The division and headings of this Agreement are for reference only and are not to affect
        construction or interpretation.
      </p>
      <h3>11.12.</h3>
      <p>
        All capitalized terms and expressions used in this Agreement not defined herein shall
        have the same meaning as in the Xpress Application Form.
      </p>
      <h3>11.13.</h3>
      <p>
        In the event either party shall be delayed or hindered in or prevented from the
        performance of any act required to be performed by such party pursuant to this Agreement
        by reason of acts of God, strikes, lockouts, labour trouble, unavailability of or
        inability to procure materials or applicable similar substitutes, failure or power,
        prohibitive governmental laws, regulations or order, riots, insurrections, the act or
        failure to act of the other party, adverse weather conditions preventing the performance
        of work as certified to by an architect, war or other reason beyond such party&rsquo;s
        reasonable control, then the time for performance of such act shall be extended for a
        period equivalent to the period of such delay. Lack of adequate funds or financial
        inability to perform or to meet monetary obligations shall not be deemed to be a cause
        beyond the control of such party. Further, and in particular, and notwithstanding that a
        force majeure event enumerated above may have occurred, the Customer shall remain
        obligated at all times to pay all Xpress Fleet Card Invoices in full as and when it falls
        due under this Agreement, without setoff or abatement of any kind.
      </p>
      <h3>11.14.</h3>
      <p>
        The Customer shall not disclose any information pertaining to the Xpress Application Form
        or this Agreement to any third party without the prior written consent of Canco, except
        such information as required by law to be disclosed or reasonably required to be
        disclosed by the Customer to the Customer&rsquo;s lenders, insurers, or professional
        advisors.
      </p>

      <p className={styles.termsEndMarker}>
        <strong>[End of Xpress Terms and Conditions]</strong>
      </p>
    </div>
  );
};

export default XpressTermsContent;
